import React, { useState } from "react";
import { Box, VStack, IconButton, Tooltip, Text } from "@chakra-ui/react";
import styles from "./LeftPanel.module.css";
import Corrections from "./Corrections";
import Query from "./Query";
import Toppanel from "./Toppanel";
import { VscFiles, VscCommentDiscussion, VscGitCompare, VscListSelection } from "react-icons/vsc";
import { AiOutlineRobot } from "react-icons/ai";
import TableOfContents from "./TableOfContents";
import Copilot from "./Copilot";

function LeftPanel(props) {
  const [view, setView] = useState("copilot");

  const SidebarIcon = ({ icon, label, isActive, onClick }) => (
    <Tooltip label={label} placement="right" hasArrow>
      <Box
        w="100%"
        h="50px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
        className={isActive ? styles["active-icon"] : ""}
        onClick={onClick}
        borderLeft={isActive ? "2px solid #007fd4" : "2px solid transparent"}
        _hover={{ color: "#fff" }}
        color={isActive ? "#fff" : "#858585"}
      >
        <IconButton
          icon={icon}
          variant="unstyled"
          fontSize="24px"
          aria-label={label}
          minW="auto"
          h="auto"
          _focus={{ boxShadow: "none" }}
        />
      </Box>
    </Tooltip>
  );

  return (
    <Box display="flex" width="100%" height="100%" backgroundColor="#252526" overflow="hidden">
      {/* Activity Bar */}
      <VStack
        width="42px"
        minW="42px"
        height="100%"
        backgroundColor="#333333"
        spacing={0}
        pt={2}
        borderRight="1px solid #1e1e1e"
      >
        <SidebarIcon
          icon={<AiOutlineRobot />}
          label="Copilot"
          isActive={view === "copilot"}
          onClick={() => setView("copilot")}
        />
        <SidebarIcon
          icon={<VscFiles />}
          label="Project Files"
          isActive={view === "files"}
          onClick={() => setView("files")}
        />
        <SidebarIcon
          icon={<VscCommentDiscussion />}
          label="Comments"
          isActive={view === "queries"}
          onClick={() => setView("queries")}
        />
        <SidebarIcon
          icon={<VscGitCompare />}
          label="Corrections"
          isActive={view === "corrections"}
          onClick={() => setView("corrections")}
        />
        <SidebarIcon
          icon={<VscListSelection />}
          label="Table of Contents"
          isActive={view === "toc"}
          onClick={() => setView("toc")}
        />
      </VStack>

      {/* Sidebar Content */}
      <Box flex={1} height="100%" overflowY="auto" backgroundColor="#252526">
        <Box
          h="35px"
          display="flex"
          alignItems="center"
          px={4}
          bg="#252526"
          fontSize="11px"
          fontWeight="bold"
          color="#BBBBBB"
          textTransform="uppercase"
          letterSpacing="0.05em"
        >
          <Text>
            {view === "copilot" && "Copilot"}
            {view === "files" && "Project Files"}
            {view === "queries" && "Comments"}
            {view === "corrections" && "Corrections"}
            {view === "toc" && "Structure"}
          </Text>
        </Box>

        <Box height="calc(100% - 35px)" overflowY="auto">
          {view === "copilot" && <Copilot editorRef={props.editorRef} />}
          {view === "files" && (
            <Toppanel
              current_file={props.current_file}
              projectfiles={props.projectfiles}
              getprojectfiles={props.getprojectfiles}
              projectid={props.projectid}
              loadProjectDetails={props.loadProjectDetails}
              setOpenFiles={props.setOpenFiles}
              openFiles={props.openFiles}
            />
          )}
          {view === "queries" && <Query ace={props.editorRef} />}
          {view === "corrections" && (
            <Corrections corrections={props.corrections} ace={props.editorRef} />
          )}
          {view === "toc" && <TableOfContents ace={props.editorRef} />}
        </Box>
      </Box>
    </Box>
  );
}

export default LeftPanel;
